import { makeAutoObservable } from 'mobx';
import { ReactNode } from 'react';

/**
 * 프레임(<Frame>)과 제목(<Title>) 관련 스토어
 */
class FrameStore {
    currentTitle: ReactNode = null;

    constructor() {
        makeAutoObservable(this);
    }

    setCurrentTitle(title: ReactNode) {
        this.currentTitle = title;
    }
}

export default new FrameStore();
